export default __webpack_public_path__ + "static/media/efectos_personas.408925f0.png";